import { createAction } from 'redux-starter-kit';

export const SET_PERFORMANCE_PERIOD = 'investment-analyser/performance-period';
export const SET_RISK_PERFORMANCE_PERIOD =
  'investment-analyser/risk-performance-period';
export const SET_RESEARCH_INVESTMENTS =
  'investment-analyser/research-investments';
export const SET_PAST_PERFORMANCE = 'investment-analyser/past-performance';
export const SET_ASSET_ALLOCATION = 'investment-analyser/asset-allocation';
export const SET_COUNTRY_BREAKDOWN = 'investment-analyser/country-breakdown';
export const SET_REGIONAL_BREAKDOWN = 'investment-analyser/regional-breakdown';
export const SET_SECTOR_BREAKDOWN = 'investment-analyser/sector-breakdown';
export const SET_RISK_RATINGS = 'investment-analyser/risk-ratings';
export const SET_SCATTER_CHART_DATA = 'investment-analyser/scatter-chart';
export const SET_CIP_OPTIONS = 'investment-analyser/set-cip-options';

const setPerformancePeriod = createAction(SET_PERFORMANCE_PERIOD);
const setRiskPerformancePeriod = createAction(SET_RISK_PERFORMANCE_PERIOD);
const setResearchInvestments = createAction(SET_RESEARCH_INVESTMENTS);
const setPastPerformance = createAction(SET_PAST_PERFORMANCE);
const setAssetAllocation = createAction(SET_ASSET_ALLOCATION);
const setCountryBreakdown = createAction(SET_COUNTRY_BREAKDOWN);
const setRegionalBreakdown = createAction(SET_REGIONAL_BREAKDOWN);
const setSectorBreakdown = createAction(SET_SECTOR_BREAKDOWN);
const setRiskRatings = createAction(SET_RISK_RATINGS);
const setScatterChartData = createAction(SET_SCATTER_CHART_DATA);
const setCipOptions = createAction(SET_CIP_OPTIONS);

export const investmentAnalyserActions = {
  updatePerformancePeriod:
    (performancePeriod = '5y') =>
    (dispatch: any) => {
      dispatch(setPerformancePeriod(performancePeriod));
    },
  updateRiskPerformancePeriod:
    (riskPerformancePeriod: any) => (dispatch: any) => {
      dispatch(setRiskPerformancePeriod(riskPerformancePeriod));
    },
  updateResearchInvestments: (researchInvestments: any) => (dispatch: any) => {
    dispatch(setResearchInvestments(researchInvestments));
  },
  updatePastPerformance: (pastPerformance: any) => (dispatch: any) => {
    dispatch(setPastPerformance(pastPerformance));
  },
  updateAssetAllocation: (assetAllocation: any) => (dispatch: any) => {
    dispatch(setAssetAllocation(assetAllocation));
  },
  updateCountryBreakdown: (countryBreakdown: any) => (dispatch: any) => {
    dispatch(setCountryBreakdown(countryBreakdown));
  },
  updateRegionalBreakdown: (regionalBreakdown: any) => (dispatch: any) => {
    dispatch(setRegionalBreakdown(regionalBreakdown));
  },
  updateSectorBreakdown: (sectorBreakdown: any) => (dispatch: any) => {
    dispatch(setSectorBreakdown(sectorBreakdown));
  },
  updateRiskRatings: (riskRatings: any) => (dispatch: any) => {
    dispatch(setRiskRatings(riskRatings));
  },
  updateScatterChartData: (scatterChartData: any) => (dispatch: any) => {
    dispatch(setScatterChartData(scatterChartData));
  },
  updateCipOptions: (cipOptions: any) => (dispatch: any) => {
    dispatch(setCipOptions(cipOptions));
  }
};
